/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { computed } from '@ember/object';
import { service } from '@ember/service';
import { effortLabelFor } from '@linc-technologies/linced-common/utils/effort-labels';
import { byKeys } from '@linc-technologies/linced-common/utils/arrays';
import { currentRubricProgressions } from '@linc-technologies/linced-common/utils/rubrics';
import { classNames } from '@ember-decorators/component';

@classNames('report-builder__preview-strands-table-wrap')
export default class ReportStrandTable extends Component {
  @service
  dates;

  @service
  store;

  // Passed in
  section = null;

  subject = null;
  student = null;
  @tracked mode = 'template';
  studentSection = null;
  showEffort = false;

  sampleRows = Object.freeze([
    {
      name: 'Geometry',
      judgementLabel: 'Consolidating',
      effortLabel: 'Steady',
    },
    {
      name: 'Measurement',
      judgementLabel: 'Consolidating',
      effortLabel: 'Steady',
    },
    { name: 'Number', judgementLabel: 'Consolidating', effortLabel: 'Steady' },
  ]);

  @computed(
    'mode',
    'subject.{possibleGrades.[],school.jurisdiction}',
    'studentSection.elementProgressions.@each.{elementId,judgement,effort}',
    'student',
    'section.configuration',
    'dates.rolloverMonthDate',
  )
  get strandRows() {
    if (this.mode !== 'report') {
      return null;
    }

    let elementProgressions = currentRubricProgressions(
      this.get('studentSection.elementProgressions'),
      {
        store: this.store,
        subject: this.subject,
        student: this.student,
        rolloverMonthDate: this.dates.rolloverMonthDate,
        templateSection: this.section,
      },
    );
    let possibleGrades = this.get('subject.possibleGrades') || [];
    let jurisdiction = this.get('subject.school.jurisdiction');

    let rows = elementProgressions
      .map((entry) => {
        let elementId = entry.get('elementId');
        let element = this.store.peekRecord(
          'reports/rubric-element',
          elementId,
        );
        if (!element) {
          return null;
        }

        let judgementValue = entry.get('judgement')
          ? parseInt(entry.get('judgement'), 10)
          : null;
        let judgementGrade =
          judgementValue != null
            ? possibleGrades.find((g) => g.value === judgementValue)
            : null;

        let effortLabel = effortLabelFor(entry.get('effort'), jurisdiction);

        return {
          name: element.get('name'),
          sequence: element.get('sequence'),
          judgementLabel: judgementGrade ? judgementGrade.string : '—',
          effortLabel: effortLabel || '—',
        };
      })
      .filter(Boolean)
      .sort(byKeys('sequence'));

    return rows.length ? rows : null;
  }
}
